import { paymentOptions } from '../../const/paymentOptions';
import getPaymentAmountFromOption from '../../helpers/getPaymentAmountFromOption';
import isDCHSettlementEnrolled from '../../helpers/isDCHSettlementEnrolled';
import { t } from '../../strings/i18n';
import { required } from '../../xform';
const validateAmount = (apiContext) => {
    return (selectedPaymentOption) => {
        var _a;
        if (selectedPaymentOption === null ||
            selectedPaymentOption === undefined ||
            selectedPaymentOption === '') {
            return;
        }
        if (selectedPaymentOption === 'otherAmountOption') {
            return;
        }
        const accountSummary = apiContext.accountSummaryQueryResult.data;
        const { credit: { currentBalance } } = accountSummary;
        const oneTimePaymentAmount = (_a = Number(getPaymentAmountFromOption(selectedPaymentOption, apiContext))) !== null && _a !== void 0 ? _a : Infinity;
        if (oneTimePaymentAmount > Number(currentBalance)) {
            throw new Error(t('errors.amountGreaterThanCurrentBalance'));
        }
        if (oneTimePaymentAmount <= 0) {
            throw new Error(t('errors.otherAmountZeroError'));
        }
    };
};
export const PAYMENT_OPTION_INPUT_NAME = 'paymentOption';
const paymentOptionConfig = (apiMachineRef) => {
    const apiContext = apiMachineRef.getSnapshot().context;
    const accountSummary = apiContext.accountSummaryQueryResult.data;
    const { billing, product } = accountSummary;
    const { featureFlags } = apiContext;
    const isSettlement = isDCHSettlementEnrolled(billing, product.type, featureFlags);
    return [
        PAYMENT_OPTION_INPUT_NAME,
        isSettlement ? paymentOptions.OTHER_PAYMENT : undefined,
        'ENABLED',
        [required(t('errors.paymentAmount')), validateAmount(apiContext)]
    ];
};
export default paymentOptionConfig;
